module.exports = __webpack_public_path__ + "static/media/ChatbotLogo_NewAero.6dd3dc62.svg";